import axios from 'axios'
import { useMemo, useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { Result } from '../interfaces/Result'
import { useAuth } from './useAuth'

interface C215DeviceDeleteProps {
  execDeviceDelete: (tenant: string, deviceId: string) => Promise<Result>
  loading: loadStatus
}
// C215 デバイス削除API呼出
export const useC215DeviceDelete = (): C215DeviceDeleteProps => {
  const auth = useAuth()
  // 並列実行数と、過去に1回でも実行したかを保持
  const [inFlight, setInFlight] = useState(0)
  const [hasExecuted, setHasExecuted] = useState(false)

  const loading = useMemo(() => {
    if (inFlight > 0) return loadStatus.LOADING
    return hasExecuted ? loadStatus.LOADED : loadStatus.NONE
  }, [inFlight, hasExecuted])

  const execDeviceDelete = async (tenant: string, deviceId: string): Promise<Result> => {
    setHasExecuted(true)
    setInFlight(prev => prev + 1)
    try {
      const jwt = await auth.getJwt()
      if (jwt === '') {
        return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign({}, axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      const response = await axios.delete(`${baseUrl}${stage}${apiUrl.tenantsPath}${tenant}${apiUrl.devicesPath}${deviceId}`, {
        headers: header,
        validateStatus: () => true,
      })

      if (response.status === apiStatus.SUCCESS) {
        console.log(response.data);
        return { success: true }
      }
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } finally {
      setInFlight(prev => Math.max(0, prev - 1))
    }
  }

  return { execDeviceDelete, loading }
}
